import { useMutation } from '@tanstack/react-query'

import { CompletePageConditionalRuleModel } from '@/domain/model/forms'

import { updateCompletePageConditionalRules } from './services/updateCompletePageConditionalRules'

export const useUpdateCompletePageConditionalRules = () => {
  const mutation = useMutation({
    mutationFn: async (
      data: Omit<CompletePageConditionalRuleModel, 'is_new'>
    ) => await updateCompletePageConditionalRules(data),
  })

  const updateCompletePageConditionalRulesReq = async (
    data: Omit<CompletePageConditionalRuleModel, 'is_new'>
  ) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateCompletePageConditionalRules: updateCompletePageConditionalRulesReq,
    ...mutation,
  }
}
